export default __webpack_public_path__ + "static/media/Keeta Brand Assets new.1e230f07.svg";